import React, { useEffect, useState } from "react";

import { Button, Card, Col, Collapse, Row, Statistic } from "antd";

import moment from "moment";
import Axios from "../Axios";
import { Session } from "bc-react-session";
import ReportTable from "./Dashboard/ReporTable";
import PenaltiesReport from "./Dashboard/PenaltiesReport";
import PenaltiesByOperatorTable from "./Dashboard/PenaltiesByOperatorTable";
import GrowChart from "./Heat/GrowChart";
const { Panel } = Collapse;

const Dashboard = () => {
  const [reportStatus, setReportStatus] = useState([]);
  const periodAndroid = moment().add(-3, "day");
  const session = Session.get();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGrowth, setIsLoadingGrowth] = useState(false);

  const [stats, setStats] = useState({
    android: {
      total_downloads: 0,
      active_installs: 0,
    },
    ios: {
      total_downloads: 0,
      current_month: 0,
    },
  });

  const getDownloads = async () => {
    setIsLoading(true);
    try {
      const res = await Axios.get("/analytics/downloads", {
        params: {
          date: periodAndroid.format("YYYY-MM-DD"),
          country: session.payload.authority.country,
        },
      });
      setStats(res.data);
    } catch (error) {}

    setIsLoading(false);
  };

  const getReporBySatatus = async () => {
    setIsLoadingGrowth(true);
    try {
      const res = await Axios.get("/analytics/report-status-period");
      setReportStatus(res.data);
    } catch (error) {
    } finally {
      setIsLoadingGrowth(false);
    }
  };

  useEffect(() => {
    getDownloads();
    getReporBySatatus();
  }, []);

  return (
    <>
      <Collapse>
        <Panel header="Información importante" key="1">
          ¡Bienvenido(a) a VIPA! Cada día trabajamos para hacer que esta
          herramienta logre que nuestras ciudades sean mejores. Al utilizarla,
          tienes el compromiso de no compartir tu usuario, ni de compartir
          vistas/funcionalidades con personas fuera de tu organización. Es tu
          responsabilidad proteger nuestra propiedad intelectual y esperamos
          tengan un uso responsable de ella. Any queries are available!
          <br />
          El equipo VIPA
        </Panel>
      </Collapse>

      {session.payload.authority.country == "EC" &&
        session.payload.role == "admin" && (
          <Row gutter={16} style={{ marginTop: 20 }}>
            <Col xs={24} sm={12}>
              <Card loading={isLoading} title="Android">
                <Statistic
                  title={`Instalaciones en ${periodAndroid.format("MMMM")}`}
                  value={stats.android?.current_month || 0}
                />
                <Statistic
                  title={`Instalaciones activas hasta ${moment().format(
                    "MMMM YYYY"
                  )}`}
                  value={stats.android?.total_downloads || 0}
                  style={{ marginTop: 16 }}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12}>
              <Card loading={isLoading} title="iOS">
                <Statistic
                  title={`Instalaciones en ${moment().format("MMMM")}`}
                  value={stats.ios?.current_mont || 0}
                  style={{ marginTop: 16 }}
                />
                <Statistic
                  title={`Instalaciones activas hasta ${moment().format(
                    "MMMM YYYY"
                  )}`}
                  value={stats.ios.total_downloads}
                />
              </Card>
            </Col>
          </Row>
        )}
      {session.payload.role == "admin" && (
        <>
          <ReportTable
            isLoading={isLoadingGrowth}
            reportStatus={reportStatus}
          />

          <GrowChart/>
          <PenaltiesReport
            type="penalized"
            title={"Ranking Sancionados este mes"}
          />
          <PenaltiesReport
            type="attended"
            title={"Ranking No Sancionados este mes"}
          />
          <PenaltiesByOperatorTable period="today" />{" "}
        </>
      )}
    </>
  );
};

export default Dashboard;
